import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import i18n from '@lib/i18n';

window.i18nDashiFi = i18n;
window.React = React;
window.ReactDOM = ReactDOM;
window.PropTypes = PropTypes;
